// extracted by mini-css-extract-plugin
module.exports = {"viewer":"Panel_viewer__50LpE","editRow":"Panel_editRow__3VgXx","editInput":"Panel_editInput__CUoJR"};